export const parseFields = (obj, arr: [string, 'double' | 'int'][]) => {
	const out = Object.assign({}, obj);
	arr.forEach(([name, type]) => {
		try {
			out[name] = (type == 'int' ? parseInt : parseFloat)(out[name]);
		} catch (e) {
			console.error(e);
		}
	});
	return out;
};
